'use client'
import { excludedPages } from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { useSyncExternalStore } from 'react'

// Hydration-safe loading state - only show on server
const subscribe = () => () => {}
const getSnapshot = () => false
const getServerSnapshot = () => true

export default function LoadingScreen() {
  const pathname = usePathname()
  // Show loading only on server, immediately hide on client (no flash)
  const isLoading = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  if (!isLoading) return null

  return (
    <section
      className={cn(
        'fixed inset-0 z-[1002] flex h-full w-full items-center justify-center bg-white',
        excludedPages.includes(pathname ?? '') ? '' : 'xxl:hidden'
      )}
    >
      <Image
        src="/lykstage-logo.svg"
        alt="Lykstage"
        className="h-auto"
        width={200}
        height={48.8}
        priority
      />
    </section>
  )
}
